export default __webpack_public_path__ + "static/media/255.8d32bb70.jpg";